<template>
  <v-dialog
      persistent
      v-model="dialog"
      max-width="900"
      style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{ processType == "new" ? "Kullanıcı Ekle" : "Kullanıcı Düzenle" }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.firstName"
                  label="Ad"
                  :error-messages="
                  validationMessages($v.editUser.firstName, 'Ad')
                "
                  prepend-inner-icon="mdi-account"
                  @input="$v.editUser.firstName.$touch()"
                  @blur="$v.editUser.firstName.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.lastName"
                  label="Soyad"
                  :error-messages="
                  validationMessages($v.editUser.lastName, 'Soyad')
                "
                  prepend-inner-icon="mdi-account"
                  @input="$v.editUser.lastName.$touch()"
                  @blur="$v.editUser.lastName.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.email"
                  label="E-Posta"
                  :error-messages="
                  validationMessages($v.editUser.email, 'E-Posta')
                "
                  prepend-inner-icon="mdi-email"
                  @input="$v.editUser.email.$touch()"
                  @blur="$v.editUser.email.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.userName"
                  label="Kullanıcı Adı"
                  :error-messages="
                  validationMessages($v.editUser.userName, 'Kullanıcı Adı')
                "
                  prepend-inner-icon="mdi-account-arrow-right"
                  @input="$v.editUser.userName.$touch()"
                  @blur="$v.editUser.userName.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6" v-if="processType == 'new'">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.password"
                  label="Şifre"
                  :error-messages="
                  validationMessages($v.editUser.password, 'Şifre')
                "
                  prepend-inner-icon="mdi-key"
                  @click:append="showPassword = !showPassword"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @input="$v.editUser.password.$touch()"
                  @blur="$v.editUser.password.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.trin"
                  label="T.C Kimlik No"
                  prepend-inner-icon="mdi-card-account-details"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  filled
                  solo
                  dense
                  v-model="editUser.phoneNumber"
                  label="Telefon"
                  prepend-inner-icon="mdi-phone"
                  placeholder="5xxxxxxxxx"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-select
                  dense
                  filled
                  solo
                  v-model="editUser.roleGroup"
                  label="Rol Grup"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item"
                  :error-messages="
                  validationMessages($v.editUser.roleGroup, 'Role Grup')
                "
                  @input="$v.editUser.roleGroup.$touch()"
                  @blur="$v.editUser.roleGroup.$touch()"
                  prepend-inner-icon="mdi-account-star"
                  :items="roleGroupList"
                  @change="roleGroupChange()"
              ></v-select>
            </div>
            <div class="col-lg-6">
              <v-select
                  filled
                  solo
                  dense
                  v-model="editUser.role"
                  label="Rol"
                  item-text="name"
                  :item-value="item => item"
                  :error-messages="validationMessages($v.editUser.role, 'Role')"
                  @input="$v.editUser.role.$touch()"
                  @blur="$v.editUser.role.$touch()"
                  prepend-inner-icon="mdi-account-star"
                  :items="roleList"
              ></v-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id == 3"
            >
              <search-select
                  :search-type="'current'"
                  @itemChange="(e) => (editUser.erpCode = e)"
                  :label="'Cari'"
              >
              </search-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id != 3"
            >
              <v-select
                  v-model="editUser.salesPersonCode"
                  label="Plasiyer"
                  filled
                  solo
                  dense
                  clearable
                  :items="salesPersonList"
                  :item-text="item => item.name"
                  :item-value="item => item.code"
              >
              </v-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id != 1 && erpSettings.userBranch"
            >
              <v-select
                  filled
                  solo
                  dense
                  v-model="editUser.branchCode"
                  label="Şube Kodu"
                  prepend-inner-icon="mdi-office-building"
                  :items="companyBranchList"
                  item-text="name"
                  item-value="code"
                  @change="companyBranchChange"
                  :error-messages="
                  validationMessages($v.editUser.branchCode, 'Şube Kodu')
                "
                  @input="$v.editUser.branchCode.$touch()"
                  @blur="$v.editUser.branchCode.$touch()"
              ></v-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id != 1 && erpSettings.userWarehouse"
            >
              <v-select
                  filled
                  solo
                  dense
                  v-model="editUser.warehouseCode"
                  label="Depo Kodu"
                  prepend-inner-icon="mdi-warehouse"
                  :items="warehouseList"
                  item-text="name"
                  item-value="code"
                  :error-messages="
                  validationMessages($v.editUser.warehouseCode, 'Depo Kodu')
                "
                  @input="$v.editUser.warehouseCode.$touch()"
                  @blur="$v.editUser.warehouseCode.$touch()"
              ></v-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id != 1 && erpSettings.userSafe"
            >
              <v-select
                  filled
                  solo
                  dense
                  v-model="editUser.cashSafeCode"
                  label="Kasa Kodu"
                  prepend-inner-icon="mdi-cash-lock"
                  :items="bankSafeDepositsList"
                  item-text="name"
                  item-value="code"
                  :error-messages="
                  validationMessages($v.editUser.cashSafeCode, 'Kasa Kodu')
                "
                  @input="$v.editUser.cashSafeCode.$touch()"
                  @blur="$v.editUser.cashSafeCode.$touch()"
              ></v-select>
            </div>
            <div
                class="col-lg-6"
                v-if="editUser.roleGroup && editUser.roleGroup.id != 1 && erpSettings.userSafe"
            >
              <v-select
                  filled
                  solo
                  dense
                  v-model="editUser.creditCardSafeCode"
                  label="Kredi Kartı Kasa Kodu"
                  prepend-inner-icon="mdi-cash-lock"
                  :items="bankSafeDepositsList"
                  item-text="name"
                  item-value="code"
                  :error-messages="
                  validationMessages($v.editUser.creditCardSafeCode, 'Kredi Kartı Kasa Kodu')
                "
                  @input="$v.editUser.creditCardSafeCode.$touch()"
                  @blur="$v.editUser.creditCardSafeCode.$touch()"
              ></v-select>
            </div>
            <div class="col-md-6 col-lg-3 col-xl-3 pt-0">
              <v-switch v-model="editUser.priceIntervention" dense inset label="Fiyata Müdahale"></v-switch>
            </div>
            <div class="col-md-3 pt-0 col-lg-3" v-if="editUser.roleGroup && editUser.roleGroup.id != 3">
              <v-switch v-model="editUser.discountIntervention" dense inset label="İskonto Müdahale"></v-switch>
            </div>
            <div class="col-md-3 col-lg-3 col-xl-3 pt-0 ml-auto">
              <v-switch v-model="editUser.showReport" dense inset label="Rapor Gösterimi"></v-switch>
            </div>
            <div class="col-md-3 col-lg-3 col-xl-3 pt-0" :class="`${editUser.roleGroup && editUser.roleGroup.id !=3 ? '' : 'ml-auto'}`">
              <v-switch v-model="editUser.sendEmail" dense inset label="E-Posta Gönderimi"></v-switch>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closeDialog()">İptal</v-btn>
        <v-btn text color="success" @click="saveForm">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  required,
  email,
} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages.js";
//import simplebar from "simplebar-vue";
import {mapActions, mapState} from "vuex";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  mixins: [validationMixin],

  validations() {
    const self = this;
    return {
      editUser: {
        firstName: {required},
        lastName: {required},
        email: {required, email},
        userName: {required},
        roleGroup: {required},
        role: {required},
        password: self.processType == "new" ? {required} : {},
        branchCode: (this.erpSettings.userBranch && this.editUser?.roleGroup?.id != 1)  ? {required} : {},
        warehouseCode: (this.erpSettings.userWarehouse && this.editUser?.roleGroup?.id != 1) ? {required} : {},
        cashSafeCode: (this.erpSettings.userSafe && this.editUser?.roleGroup?.id != 1) ? {required} : {},
        creditCardSafeCode: (this.erpSettings.userSafe && this.editUser?.roleGroup?.id != 1) ? {required} : {},
      },
    };
  },

  components: {
    SearchSelect
    //  simplebar
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    userProp: {
      type: Object,
      default: () => ({
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        passwordHash: "",
        passwordSalt: "",
        trin: "",
        phoneNumber: null,
        erpCode: "",
        erpName: "",
        salesPersonCode: null,
        branchCode: null,
        warehouseCode: null,
        projectCode: null,
        sendEmail: true,
        registerDate: "",
        isActive: true,
        lastLoginDate: "",
        loginCount: null,
        roleGroup: null,
        role: null,
        cashSafeCode: "",
        creditCardSafeCode: "",
        priceIntervention: false,
        discountIntervention: false,
        showReport: true,
      }),
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
  },
  mounted() {
    this._fetchSalesPersonList();
  },
  data() {
    return {
      currentSearchText: "",
      currentSearchResult: null,
      currentSearchLoading: false,
      dialog: false,
      showPassword: false,
      roleGroupList: [],
      roleList: [],
      warehouseList: [],
      companyBranchList: [],
      bankSafeDepositsList: [],
      editUser: {
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        passwordHash: "",
        passwordSalt: "",
        trin: "",
        phoneNumber: null,
        erpCode: "",
        erpName: "",
        salesPersonCode: null,
        branchCode: null,
        warehouseCode: null,
        projectCode: null,
        cashSafeCode: "",
        sendEmail: true,
        registerDate: "",
        isActive: true,
        lastLoginDate: "",
        loginCount: null,
        roleGroup: null,
        role: null,
        creditCardSafeCode: "",
        priceIntervention: false,
        discountIntervention: false,
        showReport: true,
      },
    };
  },
  methods: {
    ...mapActions("current", ["fetchCurrentList", "fetchSalesPersonList"]),
    ...mapActions("user", [
      "userAdd",
      "userUpdate",
      "fetchSingleUser",
      "fetchRoleGroupList",
      "fetchRoleList",
      "fetchUserList"
    ]),
    ...mapActions("company", ["fetchBranchList","fetchErpWarehouseList"]),
    ...mapActions("bank", ["fetchSafeDepositsList"]),
    validationMessages,
    roleGroupChange() {
      (this.editUser.role = null), this.getRoleList();
    },
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    async saveForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let requestBody = {
          FirstName: this.editUser.firstName,
          LastName: this.editUser.lastName,
          UserName: this.editUser.userName,
          Email: this.editUser.email,
          Password: this.editUser.password,
          Trin: this.editUser.trin,
          PhoneNumber: this.editUser.phoneNumber,
          ErpCode: this.editUser.roleGroup.id === '3' || this.editUser.roleGroup.id === 3 ? this.editUser.erpCode : "",
          SalesPersonCode: this.editUser.salesPersonCode,
          BranchCode: this.editUser.branchCode,
          WarehouseCode: this.editUser.warehouseCode,
          RoleGroupId: this.editUser.roleGroup.id,
          RoleId: this.editUser.role.id,
          CashSafeCode: this.editUser.cashSafeCode,
          SendEmail: this.editUser.sendEmail,
          ProjectCode: this.editUser.projectCode,
          isActive: this.editUser.isActive,
          CreditCardSafeCode: this.editUser.creditCardSafeCode,
          PriceIntervention: this.editUser.priceIntervention,
          DiscountIntervention: this.editUser.discountIntervention,
          ShowReport: this.editUser.showReport,
        };
        if (this.processType == 'new') {
          let result = await this.userAdd({
            body: requestBody
          })
          if (result.data.success) {
            this.dialog = false;
            this.$v.$reset();
          }

        } else {
          requestBody.Id = this.editUser.id
          let result = await this.userUpdate({
            body: requestBody
          });
          if (result.data.success) {
            this.dialog = false;
            this.$v.$reset();
          }


        }

      }
    },
    async _fetchSalesPersonList() {
      await this.fetchSalesPersonList({
        params: {},
        body: {}
      });
    },
    async _fetchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...((this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2
              ? true
              : false) && {salesPersonCode: this.user.SalesPersonCode}),
          ...((this.currentSearchText == "" || this.currentSearchText == null
              ? false
              : true) && {searchText: this.currentSearchText})
        },
        body: {},
        loading: false
      });
      this.currentSearchLoading = false;
    },
    async getRoleGroupList() {
      this.roleGroupList = await this.fetchRoleGroupList({
        params: {
          userId: this.user.UserId,
        },
      });
    },
    async getRoleList() {
      if (this.editUser.roleGroup)
        this.roleList = await this.fetchRoleList({
          params: {
            roleGroupId: this.editUser.roleGroup.id,
          },
        });
    },
    async getUser(userId) {
      this.editUser = await this.fetchSingleUser({
        urlSegments: [userId],
      });
    },
    async getWarehouseList() {
      if (this.editUser.branchCode || this.editUser.branchCode === '0' || this.editUser.branchCode === 0) {
        this.warehouseList = await this.fetchErpWarehouseList({
          params: {
            branchCode: this.editUser.branchCode,
          },
        });
      }
    },
    async getCompanyBranchList() {
      this.companyBranchList = await this.fetchBranchList({
        params: {},
      });
    },
    async getSafetyDeposits() {
      if (this.editUser.branchCode || this.editUser.branchCode === '0' || this.editUser.branchCode === 0) {
        this.bankSafeDepositsList = await this.fetchSafeDepositsList({
          params: {
            branchCode: this.editUser.branchCode,
          },
        });
      }
    },
    companyBranchChange() {
      this.getWarehouseList();
      this.getSafetyDeposits();
    },
  },
  watch: {
    userProp: async function (newVal) {
      if (this.processType == "edit") {
        await this.getUser(newVal.id);
      }
    },
    currentSearchText: function (newVal) {
      if (newVal && newVal.length > 2) {
        this.currentSearchResult = [];
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
        this.currentSearchLoading = true;
        this.searchCurrentTimeout = setTimeout(() => {
          this._fetchCurrentList();
        }, 2000);
      }
    },
    dialog: async function (newVal) {
      if (newVal) {

        await this.getRoleGroupList();


        await this.getCompanyBranchList();

        await this.getWarehouseList();

        await this.getSafetyDeposits();

        await this.getRoleList();

      } else {
        this.editUser = {
          firstName: "",
          lastName: "",
          userName: "",
          email: "",
          passwordHash: "",
          passwordSalt: "",
          trin: "",
          phoneNumber: null,
          erpCode: "",
          erpName: "",
          salesPersonCode: null,
          branchCode: null,
          warehouseCode: null,
          projectCode: null,
          sendEmail: true,
          registerDate: "",
          isActive: true,
          lastLoginDate: "",
          loginCount: null,
          roleGroup: null,
          role: null,
          cashSafeCode: "",
          creditCardSafeCode: "",
          priceIntervention: false,
          discountIntervention: false,
          showReport: true,
        };
      }

      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
  },
};
</script>